// Both inventory menus use this list so their names, order and routes stay aligned.
export const inventoryViews = [
  { key: "balances", label: "库存余额" },
  { key: "locations", label: "库位库存" },
  { key: "logs", label: "出入库流水" },
  { key: "transfers", label: "库存调拨" },
  { key: "checks", label: "库存盘点" },
  { key: "other-inbounds", label: "其它入库单" },
  { key: "other-outbounds", label: "其它出库单" },
  { key: "production-issues", label: "生产领料" },
  { key: "production-receipts", label: "成品入库" },
] as const;

export type InventoryView = (typeof inventoryViews)[number]["key"];
export const inventoryViewLabels = Object.fromEntries(
  inventoryViews.map(({ key, label }) => [key, label]),
) as Record<InventoryView, string>;
export const isInventoryView = (value: unknown): value is InventoryView =>
  inventoryViews.some(({ key }) => key === value);
